<template>
  <vx-card class="campaign-summary" :noShadow="true">
    <div class="vs-row header-divider">
      <vs-divider />
      <p class="font-bold mb-3 custom-type-style">
        {{ $t('Campaign Name') }}:
      </p>
      <p class="mb-3 custom-type-style campaign-name">
        {{ data.name }}
      </p>
    </div>

    <vs-divider class="custom-divider-style" />

    <div class="vs-row">
      <p class="font-bold mb-3 custom-type-style">
        {{ $t('Brand Name') }}:
      </p>
      <p class="mb-3 custom-type-style">
        {{ data.brand }}
      </p>
    </div>

    <vs-divider class="custom-divider-style" />

    <div class="vs-row">
      <p class="font-bold mb-3 custom-type-style">
        {{ $t('Industry') }}:
      </p>
      <p class="mb-3 custom-type-style">
        {{ industry }}
      </p>
    </div>

    <vs-divider class="custom-divider-style" />

    <div class="vs-row">
      <p class="font-bold mb-3 custom-type-style">
        {{ $t('Start & End Date') }}:
      </p>
      <p class="mb-3 custom-type-style">
        {{ data.start_date === null ? 'Once it approved' : data.start_date }} To {{ data.end_date === null ? 'No End Date' : data.end_date }}
      </p>
    </div>

    <div class="vs-row mt-4 custom-summary-button-style" v-if="!editing">
      <vs-button id="create-campaign-summary-s2-button" color="primary" type="filled" class="w-full text-sm block m-auto rounded-sm" @click="goToStep()">
        {{ $t('Edit Campaign Details') }}
      </vs-button>
    </div>
    <vs-divider class="vs-divider-custom" />
  </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      campaignCategories: 'campaign/campaignCategories'
    }),
    industry () {
      const item = this.campaignCategories.find(i => i.id === this.data.industry_id)

      if (item) {
        return item.name
      }

      return 'N/A'
    }
  },
  methods: {
    goToStep () {
      const wizard = this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.campaignWizard

      wizard.navigateToTab(1)
    }
  }
}
</script>


<style lang="scss" scoped>

    .campaign-name {
      white-space: initial;
      display: inline-block;
      word-wrap: break-word;
      line-height: 19px;
      max-width: 320px;
    }
</style>
